import { SET_MOBILE_OVERLAY } from 'redux/modules/page/actions/types';

export default function setMobileOverlay(isMobileOverlayOpen: boolean) {
  return { type: SET_MOBILE_OVERLAY, isMobileOverlayOpen };
}
